'use client';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { PatentGridRow } from './types';
import { useRouter } from '@/navigation';
import React from 'react';

const columns: GridColDef[] = [
  {
    field: 'modelNumber',
    headerName: 'Model Number',
    flex: 1,
  },
  {
    field: 'patentName',
    headerName: 'Patent Name',
    flex: 1,
  },
];

interface PatentGridProps {
  rows: Array<PatentGridRow>;
  searchQuery: string;
  page: number;
  pageSize: number;
  rowCount: number;
}

export function PatentGrid({ rows, searchQuery, page, pageSize, rowCount }: PatentGridProps) {
  const router = useRouter();
  const paginationModel = {
    page,
    pageSize,
  };
  return (
    <DataGrid
      sx={{
        border: 'none',
        '& .MuiDataGrid-footerContainer': { pt: 2 },
        '& .MuiDataGrid-topContainer': { fontSize: '1.125rem' },
        '& .MuiDataGrid-row': {
          '&:nth-of-type(odd)': { backgroundColor: 'gray.light' },
          '&:nth-of-type(even)': { backgroundColor: 'common.white' },
        },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: 'none',
        },
      }}
      disableColumnMenu
      isRowSelectable={() => false}
      columns={columns}
      rows={rows}
      rowCount={rowCount}
      autoHeight={true}
      pageSizeOptions={[10, 25, 50, 100]}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={model => {
        router.push(`/patents?search=${searchQuery}&page=${model.page}&pageSize=${model.pageSize}`);
      }}
      initialState={{
        pagination: { paginationModel: { pageSize: pageSize, page: page } },
      }}
    />
  );
}
